import { withLoginUser } from 'src/api/user'
import styled from 'styled-components'
import { ProfileEditorWrapper } from '../ProfileLayout'
import { NoticeItem } from './NoticeItem'
import { useNoticeConfiguration } from './hooks'
import { CHATWORK_SETTINGS, SLACK_SETTINGS } from 'src/utils/routes'
import NextLink from 'next/link'
import { ToggleSwitch } from './ToggleSwitch'
import { Title } from '../formComponents'
import { DecodedEmailSettings } from 'src/api/types/currentCompany'
import {
  NoticeNext,
  NoticeChatwork,
  NoticeConnected,
  NoticeEmail,
  NoticeNotConnected,
  NoticeSlack,
  NoticeSms,
} from 'src/assets/svgs'
import { mediumGray } from 'src/styles/colors'

export const NoticeConfiguration = withLoginUser(({ user }) => {
  const {
    settings,
    onChangeSettings,
    smsNoticeFlag,
    changeSmsNoticeFlag,
    isConnectedSlack,
    isConnectedChatwork,
    categoryInfos,
    emailNoticeFlag,
    changeEmailNoticeFlag,
  } = useNoticeConfiguration(user)

  if (!settings) {
    return null
  }

  const tools = [
    [
      'toggle',
      NoticeEmail,
      'メールを受信',
      emailNoticeFlag,
      changeEmailNoticeFlag,
      null,
    ],
    [
      'connect',
      NoticeSlack,
      'Slackに通知',
      isConnectedSlack,
      null,
      SLACK_SETTINGS,
    ],
    [
      'connect',
      NoticeChatwork,
      'Chatworkに通知',
      isConnectedChatwork,
      null,
      CHATWORK_SETTINGS,
    ],
    [
      'toggle',
      NoticeSms,
      'SMS(携帯電話番号)に通知',
      smsNoticeFlag,
      changeSmsNoticeFlag,
      null,
    ],
  ]

  return (
    <ProfileEditorWrapper user={user}>
      <Title
        title="通知設定"
        description="ONLY STORYで受け取る通知を個別に設定することができます"
      />
      <Form>
        <div>
          <SubTitle>通知先の設定</SubTitle>
          <NoticeTools>
            {tools.map(([type, Icon, label, value, onChange, link], i) => (
              <NoticeToolsItem key={i}>
                <NoticeToolsItemIcon>
                  <Icon />
                </NoticeToolsItemIcon>
                <NoticeToolsItemText>{label}</NoticeToolsItemText>
                <NoticeToolsItemAction>
                  {type === 'connect' ? (
                    value ? (
                      <NoticeConnected />
                    ) : (
                      <NoticeNotConnected />
                    )
                  ) : (
                    <ToggleSwitch value={value} onChange={onChange} />
                  )}
                  <NoticeToolsItemActionLabel>
                    {value
                      ? type === 'connect'
                        ? '連携済み'
                        : 'する'
                      : type === 'connect'
                      ? '未連携'
                      : 'しない'}
                  </NoticeToolsItemActionLabel>
                </NoticeToolsItemAction>
                <NoticeToolsItemArrow>
                  {link ? (
                    <NextLink href={link}>
                      <a href={link}>
                        <NoticeNext width="24" height="24" />
                      </a>
                    </NextLink>
                  ) : null}
                </NoticeToolsItemArrow>
              </NoticeToolsItem>
            ))}
          </NoticeTools>
        </div>
        <div>
          <SubTitle> 通知項目の設定</SubTitle>
          {categoryInfos.map(([k, name, _]) => (
            <div key={k as string}>
              <NoticeCategory>
                <NoticeCategoryLabel>{name}</NoticeCategoryLabel>
                <NoticeItem
                  type={'email'}
                  onChange={onChangeSettings(k)}
                  currentValue={settings[k]}
                />
                {isConnectedSlack && (
                  <NoticeItem
                    type={'slack'}
                    onChange={onChangeSettings(k + '_slack')}
                    currentValue={
                      settings[(k + '_slack') as keyof DecodedEmailSettings]
                    }
                  />
                )}
                {isConnectedChatwork && (
                  <NoticeItem
                    type={'chatwork'}
                    onChange={onChangeSettings(k + '_chatwork')}
                    currentValue={
                      settings[(k + '_chatwork') as keyof DecodedEmailSettings]
                    }
                  />
                )}
              </NoticeCategory>
            </div>
          ))}
        </div>
      </Form>
    </ProfileEditorWrapper>
  )
})

const Form = styled.form`
  padding: 10px 10px;
  max-width: 700px;
  margin: auto;
`

const SubTitle = styled.h2`
  font-size: 20px;
  padding: 16px 0;
`

const NoticeTools = styled.div`
  margin: 16px 0;
  border-radius: 5px;
  border: solid 1px #cdcdcd;
  padding: 0 16px;
`

const NoticeToolsItem = styled.div`
  display: flex;
  align-items: center;
  border-bottom: solid 1px #cdcdcd;
  padding: 24px 8px;
  &:last-child {
    border: none;
  }
`

const NoticeToolsItemIcon = styled.div``

const NoticeToolsItemText = styled.p`
  font-size: 14px;
  color: ${mediumGray};
  padding: 0 16px;
  flex: 1;
`

const NoticeToolsItemAction = styled.div`
  flex: 0.55;
  display: flex;
  align-items: center;
`

const NoticeToolsItemActionLabel = styled.div`
  font-size: 14px;
  color: ${mediumGray};
  padding-left: 8px;
`

const NoticeToolsItemArrow = styled.div`
  flex: 0.1;
  display: flex;
  justify-content: flex-end;
`

const NoticeCategory = styled.div`
  padding: 16px 0;
`

const NoticeCategoryLabel = styled.p`
  padding: 12px 16px;
  margin-bottom: 8px;
  background: #f6f6f6;
  color: ${mediumGray};
`
